import React from 'react';
import { Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { VARIANCE_STATUS_COLOR } from './ScheduleVarianceFields';

/**
 * Schedule variances as a compact list that opens the record on click. Used
 * by the supervisor's To Do and the Campaign Summary tab.
 */
export default function OpenScheduleVariancesTable({ rows, loading, pageSize = 5, showTeam = false }) {
  const navigate = useNavigate();
  const columns = [
    { title: 'Date', dataIndex: 'VarianceDate', key: 'VarianceDate', width: 100,
      render: (v) => (v ? String(v).slice(0, 10) : '—') },
    { title: 'Employee', dataIndex: 'EmployeeName', key: 'EmployeeName', ellipsis: true },
    ...(showTeam ? [{ title: 'Team', dataIndex: 'TeamName', key: 'TeamName', ellipsis: true }] : []),
    { title: 'Variance Type', dataIndex: 'VarianceType', key: 'VarianceType', ellipsis: true },
    { title: 'Hours Affected', key: 'Hours', width: 150,
      render: (_, r) => (r.ShiftStart || r.ShiftEnd ? `${r.ShiftStart || '?'} – ${r.ShiftEnd || '?'}` : '—') },
    { title: 'Remove Points', dataIndex: 'RemovePoints', key: 'RemovePoints', width: 165 },
    { title: 'Status', dataIndex: 'Status', key: 'Status', width: 90,
      render: (v) => <Tag color={VARIANCE_STATUS_COLOR[v] ?? 'default'}>{v}</Tag> },
  ];
  return (
    <Table
      rowKey="ID"
      dataSource={rows}
      columns={columns}
      loading={loading}
      size="small"
      pagination={{ pageSize, size: 'small', hideOnSinglePage: true }}
      onRow={(r) => ({ onClick: () => navigate(`/schedule-variances/${r.ID}`), style: { cursor: 'pointer' } })}
      locale={{ emptyText: 'No open schedule variances.' }}
    />
  );
}
